import { Box } from '@bechtel/gds';
import styled, { css } from 'styled-components';

export const DocumentNavStyled = styled(Box).attrs({
  p: { sm: '500' },
  alignItems: { sm: 'center' },
})`
  box-shadow:
    0 2px 4px -1px rgba(0, 0, 0, 0.2),
    0 1px 10px 0 rgba(0, 0, 0, 0.12),
    0 4px 5px 0 rgba(0, 0, 0, 0.14);
`;

export const RangeSelectorStyled = styled.input.attrs({
  type: 'range',
})`
  ${({ theme, value }) => css`
    background: linear-gradient(
      to right,
      ${theme.colors.blue[700]} 0%,
      ${theme.colors.blue[700]} ${value}%,
      #fff ${value}%,
      #fff 100%
    );
  `}
  border-radius: ${({ theme }) => theme.radii[200]};
  appearance: none;
  width: 244px;
  outline: none;
  border: 1px solid ${({ theme }) => theme.colors.grey[300]};

  &:focus {
    outline: none; /* Removes the blue border*/
  }

  &::-webkit-slider-thumb {
    appearance: none;
    border: 4px solid ${({ theme }) => theme.colors.white}; /* Not using design token as we need the exact border width */
    height: 20px;
    width: 20px;
    border-radius: ${({ theme }) => theme.radii[900]};
    padding: 8px; /* Not using design token as we need the exact padding */
    background-color: ${({ theme }) => theme.colors.blue[700]};
    cursor: pointer;
    margin-top: -8px; /* Margin is required in Chrome */
    box-shadow:
      0 2px 4px -1px ${({ theme }) => theme.colors.blue[700]},
      0 1px 10px 0 ${({ theme }) => theme.colors.blue[700]};
  }

  &::-webkit-slider-runnable-track {
    width: 100%;
    height: 8px; /* Not using design token as we need the exact height */
    cursor: pointer;
    border-radius: ${({ theme }) => theme.radii[200]};
  }
`;

export const EmptyDocumentContainerStyled = styled.div`
  position: relative;
  height: 100%;
  width: 100%;
`;

export const EmptyDocumentContentStyled = styled(Box).attrs({
  alignItems: { sm: 'center' },
  flexDirection: { sm: 'column' },
})`
  position: absolute;
  top: 40%;
  left: 40%;
`;

export const DocumentSectionStyled = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${({ theme }) => theme.colors.grey[100]};
`;

export const DocumentViewStyled = styled.div`
  height: calc(100vh - 265px);
  width: 100%;
  overflow: auto;
  padding: ${({ theme }) => theme.spacings[500]};
  & * canvas {
    margin: auto;
  }

  &:first-child {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
  }
`;
